import React from 'react';

type ConnectedPropType = {
  type: string;
  url: string;
};

type PropType = ConnectedPropType;

class VideoSource extends React.Component<PropType> {
  render() {
    const props = this.props;
    const { type, url } = props;
    let videoType = 'video/mp4';
    switch(type)
    {
      case 'HLS':
        videoType = 'application/x-mpegURL';
        break;
      case 'MP4':
        videoType = 'video/mp4';
        break;
    }

    return (
      <source src={url} type={videoType} />
    );
  }
}

export default VideoSource;
